import { Divider, Stack, Typography } from '@mui/material';
import { StyledPagination } from '@styles/PhoenixGrid/GridStyles';

interface IStandardPagination {
    paginationIconBgColor: string,
    paginationIconColor: string,
    page: number,
    pageCount: number,
    onChange: (event: React.ChangeEvent<unknown>, value: number) => void,
}

export const StandardPagination = ({ paginationIconBgColor, paginationIconColor, page, pageCount, onChange }: IStandardPagination) => {
    return (
        <Stack spacing={2} direction={'row'} justifyContent={'flex-end'}>
            <Typography variant='subtitle2'>Page: {page} of {pageCount}</Typography>
            <Divider flexItem orientation="vertical" />
            <StyledPagination
                showFirstButton
                showLastButton
                size='small'
                paginationIconBgColor={paginationIconBgColor}
                paginationIconColor={paginationIconColor}
                count={pageCount}
                page={page}
                onChange={onChange}
            />
        </Stack>
    );
};

